import {AbstractService} from "@/services/AbstractService";
import {Common} from "@/services/observer/shopify/pages/Common";
import {Product} from "@/services/observer/shopify/pages/Product";
import {Cart} from "@/services/observer/shopify/pages/Cart";
import {CheckoutShippingMethod} from "@/services/observer/shopify/pages/CheckoutShippingMethod";
import {CheckoutPayment} from "@/services/observer/shopify/pages/CheckoutPayment";
import {CheckoutSuccess} from "@/services/observer/shopify/pages/CheckoutSuccess";
import {AbstractPageObserver} from "@/services/observer/common/AbstractPageObserver";
import {app} from "@/app";

export class Pages extends AbstractService {

  pages = {
    // shopify
    common: new Common(),
    product: new Product(),
    cart: new Cart(),
    checkoutShippingMethod: new CheckoutShippingMethod(),
    checkoutPayment: new CheckoutPayment(),
    checkoutSuccess: new CheckoutSuccess()
  };

  getApplicablePages(): AbstractPageObserver[] {
    return Object.values(this.pages).filter((pageObserver: AbstractPageObserver) => pageObserver.isApplicable());
  }

  async init() {

    await Promise.all(Object.values(this.pages).map(async (pageObserver: AbstractPageObserver) => {
      await pageObserver.init();
    }));

    const applicablePages = this.getApplicablePages();

    app.debug('Observer Pages: applicablePages', applicablePages);

    await Promise.all(applicablePages.map(async (pageObserver: AbstractPageObserver) => {
      await pageObserver.beforePageLoad();
    }));

    await Promise.all(applicablePages.map(async (pageObserver: AbstractPageObserver) => {
      await pageObserver.resolve();
    }));

    await Promise.all(applicablePages.map(async (pageObserver: AbstractPageObserver) => {
      await pageObserver.afterPageLoad();
    }));
  }

}
